import { createGlobalStyle } from 'styled-components';

import bgImgDown from '../assets/images/down.jpg';
import bgImgPlay from '../assets/images/play.png';
import bgImgArrowDown from '../assets/images/down-arrow.jpg';

export const ResponsiveStyle = createGlobalStyle`
/*	12 COLUMN : RESPONSIVE GRID SYSTEM
	DEVELOPER : DENIS LEBLANC
	URL : http://responsive.gs
	VERSION : 3.0
	LICENSE : GPL & MIT */


/* 	SET ALL ELEMENTS TO BOX-SIZING : BORDER-BOX */

* {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    *behavior: url(/scripts/boxsizing.htc);
    /*	If you need support for IE7 and lower make
		sure the boxsizing.htc file is linked properly.
		More info here:  https://github.com/Schepp/box-sizing-polyfill */
}


/*	MAIN CONTAINER
	Set the width to whatever you want the width of your site to be. */

.container-fluid {
    margin: 0 20px;
}

.container {
    max-width: 1196px;
    margin: 0 auto;
}


/*	SELF CLEARING FLOATS - CLEARFIX METHOD */

.container:after,
.row:after,
.col:after,
.clr:after,
.group:after {
    content: "";
    display: table;
    clear: both;
}


/* 	DEFAULT ROW STYLES
	Set bottom padding according to preference */

.row {
    padding-bottom: 0em;
}


/* DEFAULT COLUMN STYLES */

.col {
    display: block;
    float: left;
    width: 100%;
}

@media ( min-width: 768px) {
    .gutters .col {
        margin-left: 2%;
    }
    .gutters .col:first-child {
        margin-left: 0;
    }
}


/*	COLUMN WIDTH ON DISPLAYS +768px
	You might need to play with media queries here to suite your design. */

@media ( min-width: 768px) {
    .grid_1 {
        width: 8.33333333333%;
    }
    .grid_2 {
        width: 16.6666666667%;
    }
    .grid_3 {
        width: 25%;
    }
    .grid_4 {
        width: 33.3333333333%;
    }
    .grid_5 {
        width: 41.6666666667%;
    }
    .grid_6 {
        width: 50%;
    }
    .grid_7 {
        width: 58.3333333333%;
    }
    .grid_8 {
        width: 66.6666666667%;
    }
    .grid_9 {
        width: 75%;
    }
    .grid_10 {
        width: 83.3333333333%;
    }
    .grid_11 {
        width: 91.6666666667%;
    }
    .grid_12 {
        width: 100%;
    }
    .gutters .grid_1 {
        width: 6.5%;
    }
    .gutters .grid_2 {
        width: 15.0%;
    }
    .gutters .grid_3 {
        width: 23.5%;
    }
    .gutters .grid_4 {
        width: 32.0%;
    }
    .gutters .grid_5 {
        width: 40.5%;
    }
    .gutters .grid_6 {
        width: 49.0%;
    }
    .gutters .grid_7 {
        width: 57.5%;
    }
    .gutters .grid_8 {
        width: 66.0%;
    }
    .gutters .grid_9 {
        width: 74.5%;
    }
    .gutters .grid_10 {
        width: 83.0%;
    }
    .gutters .grid_11 {
        width: 91.5%;
    }
    .gutters .grid_12 {
        width: 100%;
    }
}

@media ( max-width: 1002px) {
    .container {margin-left: 15px; margin-right: 15px;}
}
`;

export const GlobalStyle = createGlobalStyle`
* {margin: 0; padding: 0; font-family: 'Source Sans Pro';
-webkit-font-smoothing: antialiased; -moz-osx-font-smoothing: grayscale;}
body, html {height: 100%;}
body {background: #fff;}

.gray {background-color: #F9FAFC; }

/* BOTÕES */

.btn-small {display: inline-block; min-height: 50px; border:0; line-height: 50px; padding-left: 50px; padding-right: 50px; text-transform: uppercase; font-size: 18px; font-weight: 600; text-decoration: none;}
.btn-medium {display: inline-block; min-height: 60px; border:0; line-height: 60px; padding-left: 50px; padding-right: 50px; text-transform: uppercase; font-size: 22px; font-weight: 600; text-decoration: none;}
.btn-larger {display: inline-block; min-height: 70px; border:0; line-height: 70px; padding-left: 50px; padding-right: 50px; text-transform: uppercase; font-size: 22px; font-weight: 600; text-decoration: none;}
.btn-blue {background-color: #003766; color: #fff;}
.btn-yellow {background-color: #FFC400; color: #002048;}

/* FIM BOTÕES */


/* HR */

hr {display: inline-block; overflow: hidden; border: 0; height: 6px; border-radius:10px; min-width: 10%; margin: 40px 0; }
.hr-yellow {background-color: #FFC400;}
.hr-blue {background-color: #367EBC;}

/* FIM HR */


/* HEADER */

header {height: 85px; background-color: #fff;}
header .logo {display: inline-block; margin-top: 12px; }
header .logo svg {height: 60px; width: auto;}
header .back {text-align: right; padding-top: 25px;}
header .back a {height: 35px; width: 80px; display: inline-block; background-color: #4E6876; color: #fff; line-height: 32px; text-align: center; text-decoration: none; font-weight: 600;}

/* HEADER */

/* LOGIN */

.login {padding: 100px 0;}
.login h2 {text-align: center; font-size: 40px; color: #005B88; font-weight: 400; margin-bottom: 50px;}
.login form {margin: 0 auto; background-color: #fff; padding: 40px 40px 20px 40px; border-radius: 15px; -webkit-box-shadow: 0px 0px 34px 0px rgba(0,0,0,0.1); -moz-box-shadow: 0px 0px 34px 0px rgba(0,0,0,0.1); box-shadow: 0px 0px 34px 0px rgba(0,0,0,0.1);}
.login form input {height: 60px; width: 100%; border: 1px solid rgba(78,104,118,0.5); border-radius: 3px; padding-left: 15px; font-size: 16px;}
.login form p {margin-bottom: 20px; text-align: center;}
.login form button {height: 60px; background-color: #FFC700; font-size: 22px; font-weight: 700; color: #00386E; width: 100%; border: 0; text-transform: uppercase; border-radius: 3px; cursor: pointer;}
.login form .erro {border-color: #CE1C22;}
.login form .erro::placeholder {color: #CE1C22;}
.login form a {color: #005B88; font-size: 16px;}
.login .register {padding: 50px 0 0 0; text-align: center;}
.login .register h4 {font-size: 22px; color: #005B88; font-weight: 400; padding-bottom: 10px;}
.login .register a {display: block; height: 60px; border: 1px solid #00295B; width: 290px; margin: 0 auto; line-height: 60px; font-size: 18px; color: #062D58; text-decoration: none;}

/* FIM LOGIN */

.interna {height: 100%;}
.interna .white {height: 100%; background-color: #fff; position: fixed; width: 25%; z-index: 1;}
.interna .bug-height { padding-bottom: 150px; position: relative;}



/* LEFT MENU */

.left-menu {padding-top: 20px; height: 100%; position: absolute;  width: 25%; background-color: #fff; float: left; z-index: 999;}
.left-menu .header .logo {display: inline-block; margin-top: 12px; }
.left-menu .header .logo svg {height: 40px; width: auto;}
.left-menu nav {margin-top: 80px;}
.left-menu nav ul {list-style: none;}
.left-menu nav ul li {display: block; margin-bottom: 40px; position: relative;}
.left-menu nav ul li i {display: inline-block; vertical-align: middle; width: 40px;}
.left-menu nav ul li a { font-size: 17px; color: #8699A3; text-decoration: none; padding-left: 56px;}
.left-menu nav ul li label { font-size: 17px; color: #8699A3; text-decoration: none; padding-left: 56px; cursor: pointer;}

.left-menu nav ul li a:hover {color: #174EA5; font-weight: 600;}
.left-menu nav ul li a:hover i svg path {fill: #174EA5;}
.left-menu nav ul li a:hover i {font-weight: 400;}

.left-menu nav ul li a.active {color: #174EA5; font-weight: 600;}
.left-menu nav ul li a.active i svg path {fill: #174EA5;}
.left-menu nav ul li a.active i {font-weight: 400;}
.left-menu nav ul li a.active::before {background-color: #174EA5; }

.left-menu nav ul a::before {content: ""; display: inline-block; width: 6px; height: 20px; vertical-align: top; background-color: #fff; border-radius: 3px; position: absolute; left:6px;}
.left-menu nav ul a:hover::before {background-color: #174EA5; }
.left-menu nav ul li label:hover {color: #174EA5; font-weight: 600;}
.left-menu nav ul li label:hover i svg path {fill: #174EA5;}
.left-menu nav ul li label:hover i {font-weight: 400;}
.left-menu nav ul label::before {content: ""; display: inline-block; width: 6px; height: 20px; vertical-align: top; background-color: #fff; border-radius: 3px; position: absolute; left:6px;}
.left-menu nav ul label:hover::before {background-color: #174EA5; }

.left-menu .bubble {position: relative; background: #00386E; color: #FFFFFF; padding: 20px; border-radius: 10px; width: 65%; margin-left: 95px; margin-top: 10px; display: none;}
.left-menu .bubble:after { content: '';position: absolute;display: block;
 width: 0;z-index: 1;border-style: solid;border-color: #00386E transparent;border-width: 0 10px 10px; top: -10px;
left: 10%; margin-left: -10px;}
.left-menu .bubble p {margin-bottom: 15px;}
.left-menu .bubble p:last-child {margin-bottom: 0;}
.left-menu .bubble a {padding: 0; font-size: 15px; color: #fff; display: block;}
.left-menu .bubble a:hover {color: #FFC400;}
.left-menu .bubble a::before {display: none;}
.left-menu nav ul li #sub-menu {display: none;}
.left-menu nav ul li #sub-menu:checked + .bubble {display: block;}

.left-menu nav ul li.active label {color: #174EA5; font-weight: 600;}
.left-menu nav ul li.active label i svg path {fill: #174EA5;}
.left-menu nav ul li.active label i {font-weight: 400;}
.left-menu nav ul li.active label::before {background-color: #174EA5; }
.left-menu nav ul li.active .bubble {display: block;}
.left-menu nav ul li.active .bubble a.active {color: #FFC400;}


/* FIM LEFT MENU */

/* CONTENT */

.content {padding-left: 70px; float: right; position: relative; z-index: 999; width: 75%;}

/* HEADER CONTENT */

.content .header-content {text-align: right; position: relative;}
.content .header-content .user {display: inline-block; cursor: pointer; padding: 20px 0; text-align: right;}
.content .header-content .user i {width: 50px; height: 50px; display: inline-block; overflow: hidden; border-radius: 50px; vertical-align: middle;}
.content .header-content .user i img {width: auto; height: 50px;}
.content .header-content .user span {display: inline-block; vertical-align: middle; font-size: 14px; color: #062D58; font-weight: 600; padding-left: 20px;}
.content .header-content .user span::after { content: "❯";
display: inline-block; vertical-align: middle; font-size: 14px; line-height: 0; transform: rotate(90deg); font-weight: 600; margin-left: 20px;}
.content .header-content .user .bubble {position: absolute; background: #fff; color: #FFFFFF; padding: 15px; border-radius: 10px; width: 130px; margin-top: 0; right: 0; display: inline-block; display: none; -webkit-box-shadow: 0px 5px 15px 0px rgba(0,0,0,0.17); -moz-box-shadow: 0px 5px 15px 0px rgba(0,0,0,0.17); box-shadow: 0px 5px 15px 0px rgba(0,0,0,0.17);}
.content .header-content .user .bubble:after { content: '';position: absolute;display: block;
 width: 0;z-index: 1;border-style: solid;border-color: #fff transparent;border-width: 0 10px 10px; top: -10px;
left: 10%; margin-left: -10px;}
.content .header-content .user .bubble p {margin-bottom: 10px;}
.content .header-content .user .bubble p:last-child {margin-bottom: 0;}
.content .header-content .user .bubble a {padding: 0; font-size: 16px; color: #526874; display: block; text-align: left; text-decoration: none;}
.content .header-content .user:hover .bubble {display: inline-block;}
.content h3 {font-size:25px; color: #062D58; margin-top: 55px; margin-bottom: 40px;}

/* FIM HEADER CONTENT */

/* CARTEIRA DIGITAL */

.card {width: 460px; height: 275px; background-image: linear-gradient(to right top, #062d58, #053864, #034370, #014f7c, #005b88); border-radius: 30px; padding: 20px 30px; -webkit-box-shadow: 0px 5px 15px 0px rgba(0,0,0,0.3); -moz-box-shadow: 0px 5px 15px 0px rgba(0,0,0,0.3); box-shadow: 0px 5px 15px 0px rgba(0,0,0,0.3); }
.card .foto {}
.card .foto img {width: 90px; height: 90px; border-radius: 50%; border: 3px solid #FFC400;}
.card .name {font-weight: 600; font-size: 20px; color: #fff; padding:20px 0 0 10px;}
.card .name span {display: block; font-size: 14px; font-weight: 400;}
.card .dados {padding-top: 40px; position: relative;}
.card .dados i {display: inline-block; vertical-align: middle; width: 30px;}
.card .dados p {margin-bottom: 15px; color: #fff; font-size: 12px;}
.card .dados p:last-child {margin-bottom: 0;}
.card .dados .qr-code {position: absolute; top: 10px; width: 125px; height: 125px; right: -5px; overflow: hidden;}
.card .dados .qr-code img {width: 125px; height: 125px;}

/* CARTEIRA DIGITAL */

/* MINHA CONTA */

.profile {background-color: #fff; padding: 40px;  -webkit-box-shadow: 0px 5px 25px 0px rgba(0,0,0,0.2); -moz-box-shadow: 0px 5px 25px 0px rgba(0,0,0,0.2); box-shadow: 0px 5px 25px 0px rgba(0,0,0,0.2); }
.profile .view {display: inline-block; height: 60px; border: 1px solid rgba(78,105,118,0.2);padding: 15px;}
.profile .view i {display: inline-block; vertical-align: middle; width: 35px; height: 35px;}
.profile .view i svg {width: 35px; height: 35px;}
.profile .view span {font-size: 14px; color: #526874; display: inline-block; vertical-align: middle; margin-left: 15px;}
.profile .view span a {color: #005B88;}
.profile h4 {font-size: 20px; color: #526874; font-weight: 400; padding: 30px 0;}
.profile form {border-bottom: 1px solid rgba(78,105,118,0.2); padding-bottom: 30px;}
.profile form:last-child {border: 0;}
.profile form button { display: inline-block; vertical-align: middle; height: 35px; cursor: pointer; background-color: #fff; border: 1px solid #003372; font-size: 16px; color: #003372; line-height: 30px; margin-left: 25px; padding: 0 25px;}
.profile form .save {margin-left: 10px; background-color: #005B88; color: #fff; border-color: #005B88; display: none; line-height: 30px;}
.profile form .foto i {width: 90px; height: 90px; overflow: hidden; border-radius: 128px; display: inline-block; vertical-align: middle;}
.profile form .foto i img {width: auto; height: 90px;}
.profile form h5 {margin-top: 40px; font-size: 20px; color: #062D58; font-weight: 600; margin-bottom: 30px;}
.profile form p {margin-bottom: 5px;}
.profile form p input {height: 40px; border: 0; font-size: 20px; width: 50%; pointer-events: none;}
.profile form p input::placeholder {color: #526874;}
.profile form p textarea {min-height: 150px; width: 100%; border: 0; font-size: 20px; pointer-events: none;}
.profile form p textarea::placeholder {color: #526874;}
.profile form ul {overflow: hidden; list-style: none;}
.profile form ul li {float: left; margin: 0 20px 20px 0; height: 158px; width: 158px; overflow: hidden; position: relative;}
.profile form ul .add a {text-decoration: none; color: #003372;}
.profile form ul .add {border: 1px solid #707070; border-radius: 4px; text-align: center; color: #003372; display: none;}
.profile form ul .add i {display: block; color: #003372; width: 38px; height: 38px; margin: 40px auto 5px auto; border: 1px solid #003372; line-height: 34px; font-size: 34px; border-radius: 38px;}
.profile form ul .del {position: absolute; z-index: 99; top: 0; left: 0; width: 100%; display: none; height: 100%; background-color: rgba(0,0,0,0.5); border-radius: 4px; text-align: center;}
.profile form ul .del i {font-style: normal; color: #fff; font-size: 28px; display: inline-block; margin: 55px auto 0 auto; border: 2px solid #fff; width: 38px; height: 38px; border-radius: 48px; line-height: 34px;  }
.profile .active input {border: 1px solid #4E6876; padding-left: 20px; font-size: 15px; pointer-events: auto;}
.profile .active p {margin-bottom: 15px;}
.profile .active .save {display: inline-block;}
.profile .active textarea {border: 1px solid #4E6876; padding-left: 20px; padding-top: 20px; font-size: 15px; pointer-events: auto;}
.profile .active ul .add {display: block;}
.profile .active ul li .del {display: block;}

/* FIM MINHA CONTA */

/* AJ - MODELOS CONTRATOS */

.docs {}
.docs a {background-color: #fff; padding: 20px; display: block; float: left; width: 32%; margin-right: 2%; text-decoration: none; margin-bottom: 40px;}
.docs a:nth-child(3n+3) {margin-right: 0;}
.docs a .image {overflow: hidden; height: 250px;}
.docs a .image img {height: 250px; width: auto;}
.docs a p {font-size: 15px; color: #526874; font-weight: 600; margin-top: 20px; text-decoration: none; padding-right: 30px; background: url("${bgImgDown}") no-repeat; background-position: right top;}

/* FIM AJ - MODELOS CONTRATOS */

/* AJ - DÚVIDAS FREQUENTES & ENVIE SUA DÚVIDA */

.faq {background-color: #fff; padding: 40px 0 40px 40px;  -webkit-box-shadow: 0px 5px 25px 0px rgba(0,0,0,0.2); -moz-box-shadow: 0px 5px 25px 0px rgba(0,0,0,0.2); box-shadow: 0px 5px 25px 0px rgba(0,0,0,0.2); }
.faq ul {list-style: none; padding-right: 30px;}
.faq ul li {margin-bottom: 20px;}
.faq ul li label {display: block; padding: 20px; border: 1px solid #C0DBE8; border-radius: 4px;}
.faq ul li label h6 {font-size: 16px; color: #526874; font-weight: 600; position: relative;}
.faq ul li label .question p { font-size: 15px; color: #526874; margin-top: 20px;}
.faq ul li label input {display: none;}
.faq ul li label .question {max-height: 0; overflow: hidden; -webkit-transition: max-height 0.5s;
  -moz-transition: max-height 0.5s;
  -ms-transition: max-height 0.5s;
  -o-transition: max-height 0.5s;
  transition: max-height 0.5s;  }
.faq ul li label input:checked ~ .question {max-height: 800px; -webkit-transition: max-height 2s;
  -moz-transition: max-height 2s;
  -ms-transition: max-height 2s;
  -o-transition: max-height 2s;
  transition: max-height 2s;  }
.faq ul li label h6::after {content:"❯"; transform: rotate(90deg); height: 26px; width: 26px; text-align: center; display:block; position: absolute; right: 0; top: 0; color: #16539B; font-weight: 700; border-radius: 26px; -webkit-box-shadow: 0px 0px 10px 3px rgba(0,0,0,0.05); -moz-box-shadow: 0px 0px 10px 3px rgba(0,0,0,0.05);
box-shadow: 0px 0px 10px 3px rgba(0,0,0,0.05); line-height: 26px; }
.faq ul li label input:checked ~ h6::after {transform: rotate(270deg);}
.faq .contact-duvidas {text-align: left; padding-top: 20px; clear: both;}
.faq .contact-duvidas h5 {font-size: 20px; color: #526874; font-weight: 400; margin-bottom: 0;}
.faq .contact-duvidas a { color: #005B88; font-size: 20px; text-decoration: none;}
.faq .contact-duvidas a:hover {text-decoration: underline;}

.faq .categorias {float: right;}
.faq .categorias h5 { font-size: 20px; color: #062D58; font-weight: 600; margin-bottom: 20px;}
.faq .categorias ul {padding: 0; font-size: 16px;}
.faq .categorias ul li {border-bottom: 1px solid rgba(78,104,118,0.2); margin-bottom: 0; position: relative;}
.faq .categorias ul li:last-child {border: 0;}
.faq .categorias ul li a {color: #526874; text-decoration: none; display: block; padding: 15px 0 15px 20px;; }
.faq .categorias ul li a:hover {color: #174EA5;}
.faq .categorias ul li a::after {content: ""; display: inline-block; width: 6px; height: 20px; vertical-align: top; background-color: #fff; border-radius: 3px; position: absolute; right:0;}
.faq .categorias ul li a:hover::after {background-color: #174EA5; }
.enviar-duvida {background-color: #fff; padding: 40px;  -webkit-box-shadow: 0px 5px 25px 0px rgba(0,0,0,0.2); -moz-box-shadow: 0px 5px 25px 0px rgba(0,0,0,0.2); box-shadow: 0px 5px 25px 0px rgba(0,0,0,0.2); }
.enviar-duvida form {width: 100%;}
.enviar-duvida form p {margin-bottom: 20px;}
.enviar-duvida form input {height: 60px; border: 1px solid #C0DBE8; border-radius: 4px; padding-left: 20px; font-size: 16px; width: 100%;}
.enviar-duvida form textarea {min-height: 330px; border: 1px solid #C0DBE8; border-radius: 4px; padding-left: 20px; padding-top: 20px; font-size: 16px; width: 100%;}
.enviar-duvida form button {width: 100px; height: 50px; color: #fff; font-size: 18px; font-weight: 600; border-radius: 4px; border: 0; background-color: #005B88; cursor: pointer;}
.enviar-duvida form p:last-child {text-align: right; margin-bottom: 0; margin-top: 30px;}

/* FIM AJ - DÚVIDAS FREQUENTES  & ENVIE SUA DÚVIDA */

/* CURSOS ONLINE */

.cursos {}
.cursos ul {list-style: none;}
.cursos ul li {margin-bottom: 40px; border-radius: 4px;}
.cursos ul li .image {height: 220px; overflow: hidden; position: relative; border-radius: 4px;}
.cursos ul li .image img {height: auto; width: 100%;}
.cursos ul li .image .blue {background-color: rgba(6,45,88,0.6); position: absolute; top:0; left:0; height: 100%; width: 100%; }
.cursos ul li .text {padding-left: 20px;}
.cursos ul li .text h4 {font-weight: 600; font-size: 25px; color: #526874; margin-bottom: 20px;}
.cursos ul li .text p {font-size: 16px; color: #526874; margin-bottom: 30px;}
.cursos ul li .text p a {padding: 0 30px; display: inline-block; height: 50px; color: #fff; font-size: 18px; font-weight: 600; border-radius: 4px; border: 0; background-color: #005B88; cursor: pointer; text-decoration: none; line-height: 50px;}
.cursos ul li .image .play::after {content: ""; position: absolute; background: url("${bgImgPlay}") no-repeat; display: block; width: 87px; height: 87px; left:50%; margin-left: -43.5px; top:50%; margin-top: -43.5px;}

/* FIM CURSOS ONLINE */

/* FIM CONTENT */

/* FOOTER */

footer {background-color: #00274D; text-align: center; position: relative; z-index: 99;}
footer .columns {padding-top: 40px; text-align: left;}
footer .columns .col:lasr-child {text-align: right;}
footer .columns .logo-footer svg {width: 203px; height: auto;}
footer .columns p {font-size: 18px; color: #fff; overflow: hidden; padding-left: 30px; margin-bottom: 30px;}
footer .columns p i {display: inline-block; float: left; width: 5%; text-align: center;}
footer .columns p span {display: inline-block; float: left; width: 88%; padding-left: 15px;}
footer .columns p a {color: #fff; text-decoration: none;}
footer .columns .social {text-align: right;}
footer .columns .social a {margin: 0 0 0 15px; text-decoration: none;}
footer .copyright {margin-top: 60px; color:#fff; font-size: 15px;}
footer .copyright span {display: block; font-size: 12px; text-transform: uppercase; opacity: 0.5; border-top: 1px solid rgba(255,255,255,0.5); margin-top: 25px; padding-top: 25px; padding-bottom: 25px;}

/* FIM FOOTER */


/* POPUP */

.popup {background-color: rgba(0,0,0,0.75); position: fixed; width: 100%; min-height: 100%; text-align: center; top: 0; left: 0; z-index: 999999; padding-top: 5%;}
.popup .popup-content {background-color: #fff; margin: 0 auto; position: relative; display: inline-block;}
#popup-fotos {display: none;}
#popup-fotos:target {display: block;}
#popup-fotos .close {position: absolute; top: 10px; right: 10px;}
#popup-fotos .popup-content {padding: 40px 0 40px 0;}
#popup-fotos .popup-content ul {list-style: none;}
#popup-fotos .popup-content ul li {border-bottom: 1px solid rgba(78,104,118,0.2); position: relative;}
#popup-fotos .popup-content ul li:last-child {border: 0;}
#popup-fotos .popup-content ul li button {height: 60px; width: 100%; border:0; background-color: transparent; font-size: 20px; color: #526874; cursor: pointer;}
#popup-fotos .popup-content ul li input[type="file"] {height: 60px; width: 100%; opacity: 0; cursor: pointer; position: relative; z-index: 1;}
#popup-fotos .popup-content ul li label {display: block; position: absolute; top: 0; left: 0; width: 100%; height: 100%; line-height: 60px; font-size: 20px; color: #526874; }
#popup-fotos .popup-content h5 {font-size: 20px; font-weight: 400; color: #526874; margin: 20px 0;}
#popup-fotos .popup-content .biblioteca {max-height: 300px; overflow-y: scroll; padding: 0 40px;}
#popup-fotos .popup-content .biblioteca li {width: 120px; height: 120px; border: 0; overflow: hidden; float: left; margin: 10px;}
#popup-fotos .popup-content .biblioteca li a {display: block; width: 120px; height: 120px;}
#popup-edit {display: none;}
#popup-edit:target {display: block;}
#popup-edit .popup-content {padding: 30px;}
#popup-edit .popup-content .popup-head {overflow: hidden;}
#popup-edit .popup-content .popup-head a {display: block; float: left; width: 95px; border: 1px solid #003372; font-size: 18px; line-height:50px; height: 50px; text-decoration: none; color: #003372;}
#popup-edit .popup-content .popup-head button {display: block; float: right; width: 95px; border: 1px solid #003372; background-color: #003372;  font-size: 18px; line-height:50px; height: 50px; color: #fff; cursor: pointer;}
#popup-edit .popup-content .edit {width: 100%; height: 300px; background-color: #EFEFEF; margin-top: 30px;}
#popup-edit .popup-content .edit .crop {background-color: #fff; overflow: hidden; width: 300px; height: 300px; margin: 0 auto; display: block; border-radius: 300px; cursor: pointer;}

/* FIM POPUP */



/*_____________________ RESPONSIVO _____________________*/

@media (max-width: 768px) {
 header {border-top: 4px solid #FFC400; height: 72px;}
 header .col {width: 50%; position: relative;}
 header .col svg {height: 45px; width: auto;}
 header .back a {height: 0;}
 header .back a::after {content:"❯"; transform: rotate(180deg);  display: block; position: absolute; top: 20px; height: 30px; right: 0; color: #526874; font-size: 25px;}
 .login {padding-top: 30px;}
 .login h2 {font-size: 25px; margin-bottom: 30px;}
 .login form {padding: 20px 20px 10px 20px;}
 .login .register {padding-top: 30px;}
 .login .register h4 {font-size: 20px;}

 .white {display: none;}
 .interna {background-color: #fff;}
 .interna .bug-height {margin-left: 0; margin-right: 0;  background-color: #F9FAFC; }
 .interna .bug-height {padding-bottom: 50px;}


 .left-menu {width: 100%; position: relative; padding: 0; float: none;}
 .left-menu .header {border-top: 4px solid #FFC400; height: 72px; padding-left: 20px; padding-right: 20px; border-bottom: 1px solid #DDDDDD;}
 .left-menu .header .logo svg {height: 45px; width: auto;}
 .left-menu nav {position: fixed; bottom: 0; background-color: #fff; width: 100%; z-index: 999999;}
 .left-menu nav ul {overflow: hidden;}
 .left-menu nav ul li {width: 20%; float: left; text-align: center; line-height: 12px; margin-bottom: 0; position: inherit;}
 .left-menu nav ul li a {font-size: 11px; text-align: center; padding: 15px 5px; display: block;}
 .left-menu nav ul li a i {margin-bottom: 7px;}
 .left-menu nav ul a::before {display: none;}
  .left-menu nav ul li label {font-size: 11px; text-align: center; padding: 15px 5px; display: block;}
 .left-menu nav ul li label i {margin-bottom: 7px;}
 .left-menu nav ul label::before {display: none;}
 .left-menu .bubble {width: 100%; margin-left: 0; position: inherit; height: 125px;}
 .left-menu .bubble .sub {width: 100%; position: absolute; left: 0; bottom: 0; height: 125px; background-color: #fff; padding: 0 20px;}
 .left-menu .bubble .sub p {margin: 0;}
 .left-menu .bubble .sub p:first-child {border-top: 1px solid #154EA5; background: url("${bgImgArrowDown}") no-repeat; background-position: center top; padding-top: 10px;}
 .left-menu .bubble .sub a { display: block; color: #8699A3; font-size: 14px; padding: 12px 0; border-bottom: 1px solid #DDDDDD;}
 .left-menu .bubble .sub p:last-child a {border: 0;}
 .left-menu .bubble:after {display: none;}

 .content {float: none; padding: 0; width: 100%; background-color: #F9FAFC; padding-left: 20px; padding-right: 20px; position: relative; z-index: auto;}
 .content h3 {font-size: 24px; margin-bottom: 20px; color: #005B88; margin-top: 15px;}
 .content .header-content .user {width: auto; text-align: right; padding: 15px 0;right: 0; top: -85px; position: absolute; z-index: 99999;}
 .content .header-content .user i {width: 42px; height: 42px; float: right;}
 .content .header-content .user i img {height: 42px; width: auto;}
 .content .header-content .user span {font-size: 0; padding: 0;}
 .content .header-content .user span::after {content: "☰"; margin-right: 5px; float: left; margin-top: 20px; transform: rotate(180deg); font-size: 20px; color: #707070;}
 .content .header-content .user .bubble {top: 60px;}
 .content .header-content .user .bubble::after {left: auto; right: 10%;}

 .card {width: 100%; height: auto; text-align: center; padding: 30px 0;}
 .card .foto {}
 .card .foto img {width: 80px; height: 80px;}
 .card .name {font-size: 20px; padding: 5px 0;}
 .card .name span {font-size: 16px;}
 .card .dados {padding-top: 20px;}
 .card .dados p {font-size: 13px; text-align: left; padding: 10px  20px; margin-bottom: 0; border-bottom: 1px solid rgba(255,255,255,0.3);}
 .card .dados p:last-child {border: 0;}
 .card .dados p i svg {width: 15px; height: auto;}
 .card .dados .qr-code {position: relative; top: 0; right: 0; text-align: center; width: 134px; height: 134px; margin: 20px auto 0 auto;}
 .card .dados .qr-code img {width: 100%; height: auto;}

 .profile {padding: 20px; border-radius: 15px;}
 .profile .view {padding: 10px; height: 60px;}
 .profile .view i {float: left;}
 .profile .view i svg {width: 34px; height: 34px; float: left;}
 .profile .view span { font-size: 14px; margin-left: 0; float: left; width: 80%; padding-left: 10px;}
 .profile h4 {font-size: 16px; padding: 30px 0;}
 .profile form .foto i {width: 90px; height: 90px;}
 .profile form .foto i img {width: 90px; height: 90px;}
 .profile form button {margin-left: 10px; height: 35px; padding: 0 7px; line-height: 35px; font-size: 14px;}
 .profile form h5 {font-size: 15px; overflow: hidden;}
 .profile form h5 span {float: left; padding-top: 5px;}
 .profile form h5 button {float: right;}
 .profile form p input {width: 100%; font-size:15px; height: 25px;}
 .profile .active p input {height: 40px;}
  .profile form p textarea {width: 100%; font-size:15px;}
 .profile form ul li {float: none; width: 100%;}
 .profile form ul li img {width: 100%; height: auto;}

 .docs a {width: 100%; display: block; float: none; }

 .faq {padding: 20px;}
 .faq ul {padding-right: 0;}
 .faq ul li label {padding: 10px; text-align: center;}
 .faq ul li label h6::after {display: none;}
 .faq .categorias {margin-bottom:30px;}
 .faq .categorias ul li a {padding-left: 0;}
 .faq .contact-duvidas {padding-top: 10px;}
 .faq .contact-duvidas h5 {font-size: 14px;}
 .faq .contact-duvidas h5 a {display: block; font-size: 15px;}

 .enviar-duvida {padding: 20px;}
 .enviar-duvida p textarea {min-height: 200px;}

 .cursos ul li { border-bottom: 1px solid #4E6876;}
 .cursos ul li:last-child { border-bottom: 0;}
 .cursos ul li .image img {height: 220px; width: auto;}
 .cursos ul li .text {padding-left: 0; padding-top: 20px;}
 .cursos ul li .text h4 {font-size: 20px; line-height: 22px;}
 .cursos ul li .text p { font-size: 14px;}
 .cursos ul li .text p a {height: 30px; line-height: 30px; font-size: 14px;}


 footer {padding-bottom: 80px; text-align: center; padding-top: 30px;}
 footer .columns {padding-top: 0; text-align: center;}
 footer .columns .logo-footer {padding-bottom: 40px;}
 footer .columns .logo-footer svg {height: 70px; }
 footer .columns p {text-align: left; margin-bottom: 10px; font-size: 15px;}
 footer .social {text-align: center !important; padding-top: 40px;}

 .popup {padding: 15px; z-index: 9999999999;}
 .popup .popup-content {width: 100%;}
 #popup-fotos .popup-content .biblioteca {max-height: 200px; padding: 0 20px;}
 #popup-fotos .popup-content .biblioteca li {width: 105px; height: 105px;}
 #popup-edit .popup-content {padding: 20px;}
 #popup-edit .popup-content .edit {height: 160px;}
 #popup-edit .popup-content .edit .crop {width: 160px; height: 160px;}

}
@media (max-width: 320px) {

}
`;
